import { render } from "./NewTrainingForm.vue?vue&type=template&id=5c4438bf&scoped=true"
import script from "./NewTrainingForm.vue?vue&type=script&lang=js"
export * from "./NewTrainingForm.vue?vue&type=script&lang=js"

import "./NewTrainingForm.vue?vue&type=style&index=0&id=5c4438bf&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4438bf"]])

export default __exports__